import { useCallback } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useCreateVehicleOilFilterMutation } from '../../../redux/api/vehicleApi'
import { OrderCartResponse, VehicleEntry } from '../../../sdk'
import { getVehicleYMM } from '../../../utils/getVehicleYMM'
import { isVehicleCustom } from '../../../utils/isVehicleCustom'

const oilFilterTaxonomyJson = JSON.stringify({
  category: {
    id: 71,
    name: 'Engine'
  },
  subcategory: {
    id: 153,
    name: 'Filters'
  },
  partType: {
    id: 5340,
    name: 'Engine Oil Filter'
  }
})

export const useUpdateOilFilterMappingWithCartInfo = () => {
  const [createMapping] = useCreateVehicleOilFilterMutation()
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const updateOilFilterMappingWithCartInfo = useCallback(
    (response: OrderCartResponse, vehicle: VehicleEntry | undefined) => {
      if (!vehicle || !response.orderedCart?.orders) {
        return
      }
      const parts = response.orderedCart!.orders!.flatMap(
        (order) => order.parts!
      )

      for (const part of parts) {
        const partNumber = part.partNumber
        const brandName = part.brandName
        const taxonomy = part.partTaxonomy
        if (
          JSON.stringify(taxonomy) === oilFilterTaxonomyJson &&
          partNumber &&
          brandName
        ) {
          createMapping({
            authorization: accessToken,
            vehicleOilFilterInfo: {
              shop: shopId,
              vehicle: vehicle.id!,
              vehicleYMMSE: getVehicleYMM(vehicle),
              oilFilter: {
                partNumber,
                brandName
              },
              isCustom: isVehicleCustom(vehicle)
            }
          })
        }
      }
    },
    [accessToken, createMapping, shopId]
  )
  return { updateOilFilterMappingWithCartInfo }
}
